export const StatusEnum = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  All: 'All',
};

export const StatusOptionEnum = {
  OPEN: 'O',
  CLOSED: 'C',
};

export const NewEditPhysicalEnum = {
  NEW: '0',
  EDIT: '1',
};

export const SiteStatusEnum = {
  EMPTY: '0',
};

export const TypeEnum = {
  TYPE: 'P',
};

export const GroupByEnum = {
  ACCOUNTCATEGORY: 1,
  NONE: 0,
};

export const SaveOptionsEnum = {
  SaveOnly: 0,
  SaveUpdateOnHandAndClose: 1,
};


// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/PhysicalEnum.js